//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/BasePart.js";
let d=[[],[[["font_name"],"AddFont",{R_:{font_index:''}},1,0],[["font_index"],"GetFontName",{R_:{name:''}},1,0],[["font_index"],"DoesFontExist",{R_:{exists:''}},1,0],[[],"GetLength",{R_:{number_of_fonts:''}},0,0],[["font_name","type"],"AddFontWithNameAndType",{R_:{font_index:''}},2,0],[["font_index","type","font_name"],"ReplaceFont",{},3,0],[["font_index"],"GetFontType",{R_:{type:''}},1,0]],[]];
SPLM.FontCollection = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.FontCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.FontCollection.Type = Object.freeze({
    "Nx" : "Nx", "Standard" : "Standard", "Empty" : "Empty"});

export default SPLM;